import React from "react";
import { Container } from "react-bootstrap";
import "./customproduct.scss";

function ValuedClient() {
  return (
    <section className="valued-client-section">
      <Container fluid>

        <div className="text-center mb-4">
          <h2 className="section-title">Our Valued Clients</h2>
          <p className="section-subtitle">
            Trusted by leading businesses and institutions
          </p>
        </div>

        <div className="logo-slider">
          <div className="logo-track">

            {/* Logos */}
            <div className="logo-item">
              <img src="/logos/bloosm-school-logo.png" alt="Client 1" />
            </div>
            <div className="logo-item">
              <img src="/logos/gurukrupa-finance.png" alt="Client 2" />
            </div>
            <div className="logo-item">
              <img src="/logos/silveroak-school-logo.png" alt="Client 3" />
            </div>
            <div className="logo-item">
              <img src="/logos/trimurti-logo.jpeg" alt="Client 4" />
            </div>
            <div className="logo-item">
              <img src="/logos/udyog-mantra-logo-Red.png" alt="Client 5" />
            </div>
            <div className="logo-item">
              <img src="/logos/gurukrupa-finance.png" alt="Client 6" />
            </div>

            {/* Duplicate logos for smooth infinite loop */}
            <div className="logo-item">
              <img src="/logos/bloosm-school-logo.png" alt="Client 1" />
            </div>
            <div className="logo-item">
              <img src="/logos/gurukrupa-finance.png" alt="Client 2" />
            </div>
            <div className="logo-item">
              <img src="/logos/silveroak-school-logo.png" alt="Client 3" />
            </div>
            <div className="logo-item">
              <img src="/logos/trimurti-logo.jpeg" alt="Client 4" />
            </div>
            <div className="logo-item">
              <img src="/logos/udyog-mantra-logo-Red.png" alt="Client 5" />
            </div>
            <div className="logo-item">
              <img src="/logos/gurukrupa-finance.png" alt="Client 6" />
            </div>

          </div>
        </div>

      </Container>
    </section>
  );
}

export default ValuedClient;
